import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { SocialSalesSourceCreateInput } from "@/modules/social-sales-sources/domain/contracts";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateSocialSalesSourceMutation } from "../api/queries";
import { SocialSalesSourceForm } from "../ui/SocialSalesSourceForm";

export function SocialSalesSourceCreatePage() {
  const nav = useNavigate({ from: "/app/settings/social-sales-sources/new" });
  const create = useCreateSocialSalesSourceMutation();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແຫຼ່ງຂາຍ Social Media",
              to: "/app/settings/social-sales-sources",
            },
            { label: "ເພີ່ມໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <h2 className="font-bold text-2xl tracking-tight">ເພີ່ມແຫຼ່ງຂາຍ</h2>
          <Button
            variant="outline"
            onClick={() =>
              nav({ to: "/app/settings/social-sales-sources" } as never)
            }
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="rounded-xl border bg-card p-6">
          <SocialSalesSourceForm
            mode="create"
            submitting={create.isPending}
            onSubmit={async (values) => {
              await create.mutateAsync(values as SocialSalesSourceCreateInput);
              nav({ to: "/app/settings/social-sales-sources" } as never);
            }}
            onCancel={() =>
              nav({ to: "/app/settings/social-sales-sources" } as never)
            }
          />
        </div>
      </Main>
    </>
  );
}
